import { render, staticRenderFns } from "./FormOrder.vue?vue&type=template&id=39d84d65&scoped=true"
import script from "./FormOrder.vue?vue&type=script&lang=js"
export * from "./FormOrder.vue?vue&type=script&lang=js"
import style0 from "./FormOrder.vue?vue&type=style&index=0&id=39d84d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d84d65",
  null
  
)

export default component.exports